$(document).ready(function(){


/*
if($("#header_container").length){ //only if header content is present
	$(window).resize(updateStickies);
}
*/

/* add margin to body when nav is fixed to prevent jump to new content height */

var navHeight =  $('#sm_sticky_header').outerHeight(true);
$('#sm_sticky_header').on('affixed.bs.affix', function () {
	
	// console.log("DEBUG; KEEP INTRO"); return;
	
	$("body").css('margin-top',  navHeight);
	// $("body, #sm_footer_logos .row").css('margin-top',  navHeight);
	$("#sm_footer_logos").addClass("fade-visible");	
	$("#leaf-cont").addClass("affix");
	
	
	
	
	
	//remove intro
	if($("#intro-wrapper").length && !isMobile()){ 
		
		$("#header-container").remove();
		initStickies();
		TweenMax.killTweensOf($("#intro-leaf-wrapper"));
		
		// window.scrollTo(0, 0);
		
		setTimeout(function(){
			window.scrollTo(0, 0);
		}, 100);
	}
	
});

$('#sm_sticky_header').on('affixed-top.bs.affix', function () {
	// $("body, #sm_footer_logos .row").css('margin-top',  0);
	$("body").css('margin-top',  0);
	$("#sm_footer_logos").removeClass("fade-visible");
	$("#leaf-cont").removeClass("affix");	
});


if ( $('#sm_sticky_header').hasClass('affix') ) {   
	$("#sm_footer_logos").addClass("fade-visible");	
}

	

/* 
 * create vendor logo carousels on produkt detail pages 
 */
$(".owl-carousel").owlCarousel({
	// stagePadding: 50,
	loop:true,
	margin:10,
	nav:true,
	dots:false,
	// autoplay: true,
	autoplayTimeout: 3000,
	smartSpeed:1000,
	navText: [],
	responsive:{
		0:{
			items:1
		},
		470:{
			items:2
		},
		787:{
			items:3
		},
		1180:{
			items:4
		}
	}
});



$('#mobile-btn').bind('touchstart', function(e) {
    $(this).trigger('click');
    e.preventDefault();
});



/* move read more link into previous p tag */

/*
$("a.read-more").each(function(){
	$(this).prev("p").append($(this));
});
*/

/* 
TODO: shorten collapse animation, or use own transition
$.fn.collapse.Constructor.TRANSITION_DURATION = 0;
 */

 
 
// console.log($.fn.collapse.Constructor.TRANSITION_DURATION);

// alert("running...");
/*
$("#mobile-btn").click(function(event){
// $("#mobile-btn").bind("click touchstart", function(event){
	// $('#mobile-menu').collapse('toggle');
	// event.stopPropagation();
	
	// event.preventDefault();
	$(".navbar-mobile .navbar-header").append( "click " );
	$("#mobile-menu").toggleClass( "open" );
	$(this).toggleClass( "open" );
	
	// alert("is open:" + $("#mobile-menu").hasClass( "open" ));
});

*/

/*
$("#mobile-menu").find("a.dropdown-toggle").click(function(event) {
	// event.stopPropagation();
});
*/


//menu links mit flyout klickbar machen 
// $("#menu-hauptmenue").find(".dropdown>a").click(function(event) {


/*
$("#menu-hauptmenue").find(".tap-to-open.dropdown>a").click(function(event) {	
	window.location.href = $(this).attr("href");
});
*/

// $("#menu-hauptmenue").find(".menu-produkte.dropdown>a").click(function(event) {
$("#desktop-menu").find(".tap-to-open.dropdown>a").click(function(event) {
	// console.log("tap to open clicked", $("#breakPointHookMD"), $("#breakPointHookMD").is(":visible"));
	if($("#breakPointHookMD").is(":visible")){ //only on md breakpoint
		window.location.href = $(this).attr("href");
	}
});


$("#mobile-menu").find(".dropdown-submenu").click(function(event) {
	// stop bootstrap.js to hide the parents
	event.stopPropagation();
	event.preventDefault();   //prevent scrolling to #
	
	// hide the open children		
	$( this ).find(".dropdown-submenu").removeClass('open');
	// add 'open' class to all parents with class 'dropdown-submenu'
	$( this ).parents(".dropdown-submenu").addClass('open');
	// this is also open (or was)
	$( this ).toggleClass('open');
	
	// console.log("menu click", $( this ));
});


$("#mobile-menu .menu-item-has-children").find($('a[href!="#"]')).click(function(event){ //enable clicking of real links
	// console.log("not hash link");
	$(this).parent().unbind( "click" );
	event.stopPropagation();
});


/* geht height of highest submenu dropdown to scale bg */
/*
var heights = $("#desktop-menu .fw-cont").find(".dropdown-menu").map(function (){

	var currHeight = 0;
	var count = 1;
	$.each($(this).find(">li"), function(){		// add heights of <li> because container is hidden
	
		currHeight += $(this).height();
		console.log(count, $(this).height(), currHeight);	
		count++;
	});
	return currHeight;
}).get();

maxHeight = Math.max.apply(null, heights) + 25;

$("#desktop-menu").find(".first-level").height(maxHeight);

*/

/*
// Add slideDown animation to dropdown
$('.dropdown').on('show.bs.dropdown', function(e){
	console.log("show.bs.dropdown",  $(this).find('.dropdown-menu').first());
  $(this).find('.dropdown-menu').first().stop(true, true).fadeToggle();
});

// Add slideUp animation to dropdown
$('.dropdown').on('hide.bs.dropdown', function(e){
	
	console.log("hide.bs.dropdown");
  $(this).find('.dropdown-menu').first().stop(true, true).slideUp();
});

*/

/* produc flyout, add li hover styles when mouseover product image */

$('.prod-images-cont img').each(
	
	function(){	
		var currId = $(this).attr("data-img");	
		var currElement = $(this).closest("ul.dropdown-menu").find("li[data-img='" + currId +"'] a");
		$(this).hover(
			function() {	
				$(this).parent().addClass("dimImg");
				currElement.addClass("hoverLi");
				// console.log("hover over", currId, currElement);
			},
			function() {
				$(this).parent().removeClass("dimImg");		 
				currElement.removeClass("hoverLi");
				// console.log("hover out", this);
			}
		);
		$(this).click(function(){
			window.location.href = currElement.attr("href");	
		});
		
	}
); 
    

/* Coco Tipps  */
 
$('#all-tips-link').click(function(event) {
    event.stopPropagation();
}); 
    

/* smooth scrolling */

// $('a[href*=#]:not([href=#])').not(".no-smooth").click(function() {
$(".smooth>a, a.smooth").click(function() {
	var target = $(this.hash);
	$('.collapse.in').collapse('hide');
	target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
	var doScrollBack = $(this).hasClass("scroll-back"); //for intro removal page length change
	// console.log("DEBUG: smooth", target, this);
	   if (target.length) {
		 // console.log("DEBUG: animating smooth", target, this);
		 $('html,body').animate({
			 scrollTop: target.offset().top
		}, 800, 'swing',function() {
				// Animation complete.
				 if(!$("#intro-wrapper").length && doScrollBack){
					window.scrollTo(0, 0);
				 }
		}
		);
		return false;
	}
});

  
// $(".smooth>a, a.smooth").smoothScroll();
  
  
/* auto-open collapse elements on anchor links */

if($("#accordion").length){
	
	$(window).on('hashchange', hashOpenCollapse);
	if(window.location.hash)hashOpenCollapse();
}

function hashOpenCollapse(){
	// console.log("hashOpenCollapse", window.location.hash);
	$("#accordion .collapse").collapse('hide');
    $(window.location.hash +"-collapse").collapse('show');
}
  
  
// console.log("debug:", window.location.hash + "-collapse", $(window.location.hash + "-collapse")[0].outerHTML);

/*

var flyout_level = $(".fw-cont >.container > .dropdown-menu");

flyout_level.find(">li").hover(
	function(){
		flyout_level.removeClass("menu-bg-img");
		
	},
	function(){
		flyout_level.addClass("menu-bg-img");
	}

);
  
  
  */
  
/*
$(window).scroll(function() {
	console.log("debug",  $(window).scrollTop(),  $(document).height(), $(window).height(), $(document).height()-$(window).scrollTop()-$(window).height());
});

  */
  
}); //end document ready



		
		
		
	
function initStickies(){
			
		console.log("initStickies", $(window).height());
			
	$(window).off('.affix');
	// $('#sm_sticky_header, #sm_footer_logos').removeData('bs.affix').removeClass('affix affix-top affix-bottom')
	$('#sm_sticky_header, #sm_footer_logos').removeData('bs.affix').removeClass('affix affix-top affix-bottom');

	$("body").css('margin-top',  0);
	
	//push fixed menu down for navbar
	offset = 0;
	if ($('body').hasClass('admin-bar')) {
		offset =-32; 
	}

	
	$('#sm_sticky_header').affix({
		offset: {
			top: $('#sm_sticky_header').offset().top - 1 + offset //-1 to prevent flicker, add fixed instantly when no header content
		}
	});

	
	$('#sm_footer_logos').affix({
		
		offset: {
			// bottom: parseInt($('#sm-footer').outerHeight(true)) + 20 + offset
			// bottom: parseInt($('#sm-footer').outerHeight(true)) + -40 + offset
			bottom: parseInt($('#sm-footer').outerHeight()) - 60 + offset
	
		},
		// target: $('#sm_footer_logos')
	});
	
	// console.log(parseInt($('#sm-footer').outerHeight()) + offset, parseInt($('#sm-footer').outerHeight()), parseInt($('#sm-footer').outerHeight(true)));
}

// var updateStickies = debounce(initStickies, 500);


/* limit firing of function */
function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};



/* Coco Tipps  */

function nextTip(url){
	var cocoTip = $(".coco-tip")
	// var bodyContSm = cocoTip.find(".tip-body-text.tip-sm");
	// var bodyContXs = cocoTip.find(".tip-body-text.tip-xs");
	
	var bodyContVisible = cocoTip.find(".tip-body-text:visible");
	var bodyCont = cocoTip.find(".tip-body-text");
	
	var tipNumber = cocoTip.find(".tip-number");
	var headerText = cocoTip.find(".tip-header-text");
	var subHeaderText = cocoTip.find(".tip-sub-header-text");
	var bodyText = cocoTip.find(".tip-body-text");
	var bodyTextInner = cocoTip.find(".tip-body-text-inner");
	
	var startHeight = bodyContVisible.height();
	
	// tipNumber.add(".tip-number, .tip-header-text, .tip-body-text").fadeTo(500, 0);
	tipNumber.add(headerText).add(bodyText).fadeTo(500, 0);
	
	 $.ajax({
        url: url,		
        data: {
            action: 'get_coco_tip',
			mode: 'ajax',
			tip:tipNumber.text()
		},
		dataType: 'json',
        type: 'GET'
    }).done(function( response ) {
		// console.log("DATA:", response);
		tipNumber.text(response.tip).fadeTo(500, 1);
		headerText.html(response.header).fadeTo(500, 1);
		subHeaderText.html(response.subheader).fadeTo(500, 1);
		
		bodyCont.height("auto");
		
		bodyTextInner.html(response.body);
		
		endHeight = bodyContVisible.height();
		bodyContVisible.height(startHeight).animate({
			height:endHeight
		  }, 500, "swing");
		  
		bodyText.fadeTo(500, 1);
	});	
	
}

function toggleTip(currentTip){
	var tip = $(currentTip);
	
	$(".coco-tip").each(function() {
		if(!$(this).is(tip)){
			$(this).addClass("collapsed");
		}
	});
	// $(".coco-tip").addClass("collapsed");
	tip.toggleClass("collapsed");
}



/* avoid console errors */
(function() {
    var method;
    var noop = function () {};
    var methods = [
        'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
        'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
        'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd',
        'timeline', 'timelineEnd', 'timeStamp', 'trace', 'warn'
    ];
    var length = methods.length;
    var console = (window.console = window.console || {});

    while (length--) {
        method = methods[length];

        // Only stub undefined methods.
        if (!console[method]) {
            console[method] = noop;
        }
    }
}());
